module.exports = __webpack_public_path__ + "img/totem@2x.6dbc27b4.png";